import { j as f, c as g } from "./utils-BdNIfrGQ.js";
import { t as x } from "./BaseTypography.styles-D7he6cFf.js";
import { n as h } from "./normalize-spacing-DY0KSpr_.js";
const y = (t) => {
  const {
    align: r = "left",
    size: a = "xl",
    variant: o,
    fontWeight: i = "semibold",
    modifier: s,
    truncate: n,
    color: e,
    fontFamily: m,
    spacing: c,
    children: l,
    ...p
  } = t;
  return /* @__PURE__ */ f.jsx(
    "h2",
    {
      className: g(
        x({
          variant: o,
          align: r,
          size: a,
          fontWeight: i,
          modifier: s,
          truncate: n,
          color: e,
          fontFamily: m
        }),
        h(c)
      ),
      ...p,
      children: l
    }
  );
};
export {
  y as H
};
